var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("v-data-table", {
        attrs: {
          items: _vm.custList,
          headers: _vm.headers,
          loading: _vm.custGetting,
          search: _vm.search
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function() {
              return [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", lg: "3", md: "3" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            label: "search",
                            "append-icon": "mdi-magnify"
                          },
                          model: {
                            value: _vm.search,
                            callback: function($$v) {
                              _vm.search = $$v
                            },
                            expression: "search"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "item",
            fn: function({ item }) {
              return [
                _c("tr", [
                  _c("td", [_vm._v(_vm._s(item.id))]),
                  _c("td", [_vm._v(_vm._s(item.company))]),
                  _c("td", [_vm._v(_vm._s(item.customer_category_id))]),
                  _c(
                    "td",
                    [
                      _c(
                        "tooltip-btn",
                        {
                          attrs: {
                            color: "yellow",
                            fab: "",
                            "btn-class": "mr-1",
                            tooltip: "Edit",
                            small: ""
                          },
                          on: {
                            click: function($event) {
                              return _vm.$router.push({
                                name: "customers.edit",
                                params: { customer: item.id }
                              })
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("mdi-pencil")])],
                        1
                      ),
                      !item.detail
                        ? _c(
                            "tooltip-btn",
                            {
                              attrs: {
                                "btn-class": "mr-1",
                                color: "red",
                                fab: "",
                                tooltip: "Detail",
                                small: ""
                              },
                              on: {
                                click: function($event) {
                                  return _vm.$router.push({
                                    name: "customers.detail.create",
                                    params: { customer: item.id }
                                  })
                                }
                              }
                            },
                            [
                              _c("v-icon", [_vm._v("mdi-account-box-multiple")])
                            ],
                            1
                          )
                        : _c(
                            "tooltip-btn",
                            {
                              attrs: {
                                color: "green",
                                "btn-class": "mr-1",
                                fab: "",
                                tooltip: "Detail",
                                small: ""
                              },
                              on: {
                                click: function($event) {
                                  return _vm.$router.push({
                                    name: "customers.detail.edit",
                                    params: { customer: item.id }
                                  })
                                }
                              }
                            },
                            [
                              _c("v-icon", [_vm._v("mdi-account-box-multiple")])
                            ],
                            1
                          ),
                      _c(
                        "tooltip-btn",
                        {
                          attrs: {
                            color: "purple",
                            fab: "",
                            tooltip: "Forecast",
                            small: ""
                          },
                          on: {
                            click: function($event) {
                              return _vm.$router.push({
                                name: "customers.forecasts.table",
                                params: { customerId: item.id }
                              })
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("mdi-poll")])],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }